import { Notify } from 'quasar';
import { mdiAlert } from '@quasar/extras/mdi-v7';
import { t } from 'boot/i18n';

/** One toast for a progress save that was given up on. */
export function notifySaveFailed() {
  Notify.create({
    message:
      typeof t === 'function'
        ? t('PROGRESS_SAVE_FAILED')
        : 'Your progress could not be saved.',
    color: 'negative',
    icon: mdiAlert,
    position: 'bottom',
  });
}
